import { Api } from 'helpers/ApiClient';

export class Analitics {
  static async getFullStat(id) {
    try {
      const response = await Api.client.get(
        `api/v1/accounts/${id}/stats/full_stat.json`,
      );
      return {
        data: response.data,
      };
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error showAccount',
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/analitics/api.js